import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const FooterWrapper = styled.footer`
  background: #101010;
  color: #aaa;
  padding: 2rem;
  text-align: center;
  font-size: 0.9rem;
`;

const Highlight = styled.span`
  color: ${({ theme }) => theme.secondary};
`;

const LinksWrapper = styled.div`
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 15px;

  a {
    color: #00d4ff;
    text-decoration: none;
    font-size: 0.9rem;

    &:hover {
      text-decoration: underline;
      color: #00bcd4;
    }
  }
`;

const CopyRight = styled.div`
  margin-top: 1rem;
  font-size: 0.8rem;
  color: #777;
`;

export default function Footer() {
  return (
    <FooterWrapper>
      🚀 Built with ❤️ by <Highlight>Engineer Codewala</Highlight>
      <LinksWrapper>
        <Link to="/privacy">Privacy Policy</Link>
        <Link to="/terms">Terms & Conditions</Link>
        <Link to="/refund">Refund Policy</Link>
      </LinksWrapper>
      <CopyRight>
        © {new Date().getFullYear()} Engineer Codewala. All Rights Reserved.
      </CopyRight>
    </FooterWrapper>
  );
}
